import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';


import translationEN from './locales/en/translation.json';
import translationDE from './locales/de/translation.json';
import translationTR from './locales/tr/translation.json';

const savedLang = localStorage.getItem('language') || 'de'; // fallback to English

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN },
      de: { translation: translationDE },
      tr: { translation: translationTR },
    },
    lng: savedLang,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // detection order (optional)
      order: ['localStorage', 'navigator', 'htmlTag', 'cookie'],
      caches: ['localStorage'], // persist user preference
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18n;
